import styled from "styled-components"

export const Blur = styled.div`
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 10000;
`

export const Container = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  width: calc(100% - 4rem);
  max-width: 45rem;
  margin: 0 2rem;
  background: ${(p) => p.theme.colors.background};
  top: 50%;
  left: 50%;
  transform: translate(calc(-50% - 2rem), -50%);
  border-radius: 0.6rem;
  padding: 2rem;
  color: ${(p) => p.theme.colors.black};
  z-index: 10001;

  h2 {
    border-bottom: 0.1rem solid ${(p) => p.theme.colors.greyLight};
    margin: 0 0 0.5rem 0;
    padding-bottom: 1.5rem;
    font-size: 1.8rem;
  }
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`

export const StockGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin: 1rem 0;
`

export const StockItem = styled.div`
  background: ${(p) => p.theme.colors.greyLighter};
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  border-radius: 0.6rem;
  padding: 1.5rem;

  h4 {
    margin: 0 0 0.5rem 0;
    font-size: 1.2rem;
    color: ${(p) => p.theme.colors.greyDark};
    text-transform: uppercase;
  }

  span {
    font-size: 2rem;
    font-weight: 700;
  }
`

export const IncomingStockItem = styled(StockItem)`
  grid-column: span 2;
  background: ${(p) => p.theme.colors.turquoiseLighter};
  border-color: ${(p) => p.theme.colors.turquoise};
`

export const VariantId = styled.div`
  font-size: 1.2rem;
  color: ${(p) => p.theme.colors.greyDarker};
  word-break: break-all;
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  background: ${(p) => p.theme.colors.greyLighter};
  padding: 1.5rem 2rem;
  margin: 0 -2rem -2rem -2rem;
  border-top: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0 0 0.6rem 0.6rem;
`

export const ErrorText = styled.div`
  color: ${(p) => p.theme.colors.errorText};
  background: ${(p) => p.theme.colors.errorBackground};
  padding: 1rem;
  border-radius: 0.4rem;
  font-size: 1.3rem;
  margin-bottom: 1rem;
`

export const StockValue = styled.div`
  text-align: center;

  label {
    display: block;
    font-size: 1.1rem;
    color: ${(p) => p.theme.colors.greyDark};
    margin-bottom: 0.3rem;
  }

  span {
    font-size: 1.6rem;
    font-weight: 700;
  }
`
